module.exports = __webpack_public_path__ + "static/media/deleteIcon.8743b613.svg";